//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectForm from "../../Components/SelectForm/SelectForm";

import InputForm, { AutoCompleteValue } from "../../Components/InputForm/InputForm";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import { APICall } from "../../Helpers/Network/APICalls";
import { GetUserDropdown, CommonDropdownData, insertUserrole, getUserRoleMappingDataById } from "../../Helpers/APIEndPoints/EndPoints";
import "./UserRoleMapping.css";
import { useLocation } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";

const UserRoleMapping = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const context = getContext();
  const [user, setUser] = useState<any>({});
  const [userRMId, setUserRMId] = useState<any>(0);
  const [email, setEmail] = useState("");
  const [userRoleOptions, setUserRoleOptions] = useState([]);
  const [tokenNumber, setTokenNumber] = useState<any>();
  const [userRole, setUserRole] = useState<any>();
  const [firstName, setFirstName] = useState<any>();
  const [middleName, setMiddleName] = useState<any>();
  const [lastName, setLastName] = useState<any>();
  const [formDataOnEdit, setFormDataOnEdit] = useState<any>({});
  const [isActive, setIsActive] = useState(true);
  const [isHrDod, setHrDod] = useState(false);
  const [userRoleDisabled, setUserRoleDisabled] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isActiveMode, setIsActiveMode] = useState(true);
  const [editModeIsHrDod, setEditModeIsHrDod] = useState(false);
  const [emailDisable, setEmailDisable] = useState(false);
  const [unitCodeDisabled, setUnitCodeDisabled] = useState(false);
  // const [sector, setSector] = useState("");
  // const [company, setCompany] = useState("");
  // const [location, setLocation] = useState("");
  // const [department, setDepartment] = useState("");
  // const [sectorOptions, setSectorOptions] = useState([]);
  // const [companyOptions, setCompanyOptions] = useState([]);
  // const [locationOptions, setLocationOptions] = useState([]);
  // const [departmentOptions, setDepartmentOptions] = useState([]);
  // const [designationOptions, setDesignationOptions] = useState([]);
  // const [designation, setDesignation] = useState("");
  // const [validationmessage, setValidattionmessage] = useState("");
  const [unitCodeOptions, setUnitCodeOptions] = useState([]);
  const [unitCode, setUnitCode] = useState<any>("");
  // submit validation
  const [formErrors, setFormErrors] = useState<any>({});
  let formErrorObj = {};

  useEffect(() => {
    // sectoroptions();
    // companyoptions();
    // locationoptions();
    // designationoptions();
    // departmentdropdown();
    //  setUserRoleOptions([{label:"Admin",value:"Admin"},{label:"Internal Team",value:"InternalTeam"},{label:"Loan Committiee",value:"loan committiee"}])
    showLoader();
    userRoleoptions();
    unitcodeoptions();
    hideLoader();
  }, []);

  useEffect(() => {
    if (userRoleOptions?.length > 0 && formDataOnEdit.RoleId != "") {
      let val = userRoleOptions.find((ele) => ele.Id == formDataOnEdit.RoleId);
      setUserRole(val);
    }
  }, [userRoleOptions, formDataOnEdit]);

  const userDropdown = async (e, cb) => {
    if (e.length >= 3) {
      let objq = {
        Name: e,
      };
      const resp = await APICall(GetUserDropdown, objq);
     
      let useroptions = [];
      resp?.Data?.map((d) => {
        let obj = {
          label: d.UserName,
          value: d.Id,
          email: d.email,
          sector: d.Sector,
          department: d.Department,
          unitcode: d.UnitCode,
          company: d.company,
          rolemap: d.rolemap,
          roleid: d.roleid,
          rolename: d.rolename,
          unitcodeid: d.unitcodeid,
        };
        // setEmail(d.email)

        useroptions.push(obj);
      });
      cb(useroptions);
    }
  };

  const userRoleoptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "userrole",
    });
    if (resp?.Data?.length > 0) {
      setUserRoleOptions(resp?.Data);
    }
  };
  // const sectoroptions = async () => {
  //   const resp = await APICall(CommonDropdownData, {
  //     dropdownName: "sectordd",
  //   });
  //   if (resp?.Data?.length > 0) {
  //     setSectorOptions(resp?.Data);
  //   }
  // };
  // const companyoptions = async () => {
  //   const resp = await APICall(CommonDropdownData, {
  //     dropdownName: "companydd",
  //   });
  //   if (resp?.Data?.length > 0) {
  //     setCompanyOptions(resp?.Data);
  //   }
  // };
  // const locationoptions = async () => {
  //   const resp = await APICall(CommonDropdownData, {
  //     dropdownName: "locationdd",
  //   });
  //   if (resp?.Data?.length > 0) {
  //     setLocationOptions(resp?.Data);
  //   }
  // };
  // const departmentdropdown = async () => {
  //   const resp = await APICall(CommonDropdownData, {
  //     dropdownName: "departmentdd",
  //   });
  //   if (resp?.Data?.length > 0) {
  //     setDepartmentOptions(resp?.Data);
  //   }
  // };
  // const designationoptions = async () => {
  //   const resp = await APICall(CommonDropdownData, {
  //     dropdownName: "designationdd",
  //   });
  //   if (resp?.Data?.length > 0) {
  //     setDesignationOptions(resp?.Data);
  //   }
  // };
  const unitcodeoptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "unitcodedd",
    });
    if (resp?.Data?.length > 0) {
      setUnitCodeOptions(resp?.Data);
      showLoader();
      if (state.id !== null && state.id != 0) {
        let post = {
          Id: state.id,
        };
        await UserrolemappingDataById(post, resp?.Data);
      }
      hideLoader();
    }
  };

  const onchange = (e, value) => {
    if (value === "user" && e != null) {
      setUser(e);
      setEmail(e.email || "");
      setUnitCode({ label: e.unitcode, value: e.unitcodeid });
      // setUserRole({ label: e.rolename, value: e.roleid });
      // setCompany(e.company || "");
      // setSector(e.sector || "");
      // setCompany(e.company || "");
      // setDepartment(e.department || "");
    } else {
      setUser([]);
      setEmail("");
      setUnitCode("");
      // setCompany("");
      // setLocation("");
      // setDepartment("");
      // setDesignation("");
      // setSector("");
    }
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    // user_isEmpty => user
    // email_isEmpty => email
    // userrole_isEmpty => userRole
    // sector_isEmpty => sector

    // company_isEmpty => company
    // location_isEmpty => location
    // department_isEmpty => department
    // designation_isEmpty => designation
    // unitcode_isEmpty => unitCode

    // if (!sector || sector.length <= 0) {
    //   formErrorObj["sector_isEmpty"] = "Sector can not be empty";
    // }
    // if (!company || company.length <= 0) {
    //   formErrorObj["company_isEmpty"] = "Company can not be empty";
    // }
    // if (!location || location.length <= 0) {
    //   formErrorObj["location_isEmpty"] = "Location can not be empty";
    // }
    // if (!department || department.length <= 0) {
    //   formErrorObj["department_isEmpty"] = "Department can not be empty";
    // }
    // if (!designation || designation.length <= 0) {
    //   formErrorObj["designation_isEmpty"] = "Designation can not be empty";
    // }
    // !== 1 || userRole.Id !==  4 || userRole.Id !==  5

    if (![RoleEnum.Admin, RoleEnum.EnrollmentCommittee, RoleEnum.LoanCommittee].includes(userRole?.Id) || !userRole?.Id) {
      if (!unitCode || Object.keys(unitCode).length <= 0 || unitCode.length <= 0) {
        formErrorObj["unitcode_isEmpty"] = "Unit code can not be empty";
      }
    }

    if (isHrDod) {
      if (!firstName || firstName.length <= 0) {
        formErrorObj["firstName_isEmpty"] = "First name can not be empty";
      }
      if (!lastName || lastName.length <= 0) {
        formErrorObj["lastName_isEmpty"] = "Last name can not be empty";
      }
      if (!middleName || middleName.length <= 0) {
        formErrorObj["middleName_isEmpty"] = "Middle name can not be empty";
      }
      if (!tokenNumber || tokenNumber.length <= 0) {
        formErrorObj["tokenNumber_isEmpty"] = "Token number can not be empty";
      }
    } else {
      if (!user || Object.keys(user).length <= 0 || user === "") {
        formErrorObj["user_isEmpty"] = "User can not be empty";
      }
    }

    if (!userRole || Object.keys(userRole).length <= 0 || userRole === "") {
      formErrorObj["userrole_isEmpty"] = "User role can not be empty";
    }

    if (!email || email.length <= 0) {
      formErrorObj["email_isEmpty"] = "Email id can not be empty";
    }

    setFormErrors(formErrorObj);
  };

  const insertUserroleFunction = async () => {
    showLoader();
    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });
    
    // Check if userRole is Member and ensure only one unit code is selected
    if (userRole?.Id === RoleEnum.Member && unitCode.length !== 1) {
      notify(ToastType.Error, "Each Member can have only one unit code assigned. Please select exactly one unit code.");
      //notify(ToastType.Error, "Please select exactly one unit code for the Member role.");
      hideLoader();
      return;
    }

    if (isEmpty === true) {
      let param = {
        UserMapId: user?.value ? user?.value : userRMId,
        InRoleId: userRole?.Id,
        IsActive: isActive ? 1 : 0,
        Id: state.id != null || state.id != 0 ? state.id : 0,
        IsHrDod: isHrDod,
        // unitCode.value,
        UnitCodeIds: unitCode && unitCode.length > 0 ? unitCode.map(({ value }) => value).toString() : "",
        TokenNumber: tokenNumber,
        FirstName: firstName,
        MiddleName: middleName,
        LastName: lastName,
        IsHrDod: isHrDod,
        CreatedBy: context?.Id,
        EmailHrHod: email,
      };

      const insertData = await APICall(insertUserrole, param);
      
      if (insertData?.Status === ApiStatus.Error) {
        notify(ToastType.Error, insertData?.Data?.length > 0 ? insertData?.Data?.[0] : insertData?.Message);
      } else {
        notify(ToastType.Success, "User role assigned successfully.");
        navigate(-1);
      }
    }
    hideLoader();
  };

  const UserrolemappingDataById = async (id, optionArr) => {
    const resp = await APICall(getUserRoleMappingDataById, id);
    
   
    if (resp?.Data?.Data?.length > 0) {
      if (resp?.Data?.Data[0]?.IsHrDod || resp?.Data?.Data[0]?.IsHrDod == 1) {
        //userRMId,
        setUserRoleDisabled(true);
        setEditMode(true);
        setEmailDisable(false);
        setUserRMId(resp?.Data?.Data[0].Um_Id);
        setTokenNumber(resp?.Data?.Data[0].TokenNumber);
        setFirstName(resp?.Data?.Data[0].FirstName);
        setLastName(resp?.Data?.Data[0].LastName);
        setMiddleName(resp?.Data?.Data[0].MiddleName);
        setHrDod(resp?.Data?.Data[0].IsHrDod);
      } else {
        setUser({
          label: resp.Data.Data[0].Name,
          value: resp.Data.Data[0].employeeid,
        });
      }
      setEditModeIsHrDod(true);
      setFormDataOnEdit(resp.Data.Data[0]);
      setEmail(resp.Data.Data[0].email);

      if ([RoleEnum.Admin, RoleEnum.EnrollmentCommittee, RoleEnum.LoanCommittee].includes(resp.Data.Data[0]?.RoleId)) {
        setUnitCodeDisabled(true);
      }

      setUnitCode(await optionValues(optionArr, resp.Data.Data[0].UnitCodeIds));
      setIsActive(resp.Data.Data[0].IsActive);
      setIsActiveMode(false);

      // setCompany(resp.Data.Data[0].Company);
      // setSector(resp.Data.Data[0].Sector);
      // setDepartment(resp.Data.Data[0].department);
      // setUserRole({
      //   label: resp.Data.Data[0].RoleName,
      //   value: resp.Data.Data[0].RoleId,
      // });
      // setUnitCode({
      //   label: resp.Data.Data[0].unitcodevalue,
      //   value: resp.Data.Data[0].UnitCode,
      // });
    }
  };

  const optionValues = async (optionArr, data) => {
    let splitData = [];
    let getSelectedOption = [];

    if (data !== undefined && data !== "" && data !== "NULL" && data !== null) {
      splitData = data.split(",");
    }

    if (splitData.length > 0) {
      splitData.map((e, i) => {
        let temp = optionArr.find((element) => parseInt(element.value) === parseInt(e));

        if (temp.value) {
          getSelectedOption.push(temp);
        }
      });

      return getSelectedOption;
    }
    return getSelectedOption;
  };

  const handleHrHod = (e: any) => {
    setHrDod(e.target.checked);
    if (e.target.checked) {
      setUserRoleDisabled(true);
      setFormDataOnEdit({ RoleId: RoleEnum.HRHOD });
      setEmailDisable(e.target.checked);
    } else {
      setFirstName("");
      setMiddleName("");
      setLastName("");
      setUserRole();
      setTokenNumber("");
      setFormDataOnEdit({});
      setFormErrors({});
      setUserRoleDisabled(false);
      setEmailDisable(false);
    }
  };

  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const ResetFunction = () => {
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setUserRole();
    setUser();
    setEmail("");
    setUnitCode("");
    setTokenNumber("");
    setFormDataOnEdit({});
    setFormErrors({});
  };

  const updateIsMultiSelect = (role) => {
    if (role?.Id === RoleEnum.Member) {
      setIsMultiSelect(false);
    } else {
      setIsMultiSelect(true);
    }
  };

  return (
    <>
      <div>
        <div className="">
          <div className="col-lg-12 col-md-12 p-0">
            <div className="row">
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  <label className="col-form-label">Is HR/HOD</label>
                  {/* <sup>*</sup> */}
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      disabled={editModeIsHrDod ? true : false}
                      type="checkbox"
                      onChange={(e) => handleHrHod(e)}
                      name="isHrDod"
                      checked={isHrDod}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4 "></div>
              <div className="col-lg-4 col-sm-4 col-xs-4 "></div>
            </div>
            <div className="row">
              {isHrDod ? (
                <>
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group"></div>
                    <label>First Name</label>
                    <sup style={{ fontSize: "13px" }}>*</sup>
                    <InputForm placeholder={""} textArea={false} onChange={(val) => setFirstName(val?.target?.value)} value={firstName} isDisabled={editMode} />
                    <p style={{ color: "red" }}>{formErrors["firstName_isEmpty"]}</p>
                  </div>
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group"></div>
                    <label>Middle Name</label>
                    <sup style={{ fontSize: "13px" }}>*</sup>
                    <InputForm placeholder={""} textArea={false} onChange={(val) => setMiddleName(val?.target?.value)} value={middleName} isDisabled={editMode} />
                    <p style={{ color: "red" }}>{formErrors["middleName_isEmpty"]}</p>
                  </div>
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group"></div>
                    <label>Last Name</label>
                    <sup style={{ fontSize: "13px" }}>*</sup>
                    <InputForm placeholder={""} textArea={false} onChange={(val) => setLastName(val?.target?.value)} value={lastName} isDisabled={editMode} />
                    <p style={{ color: "red" }}>{formErrors["lastName_isEmpty"]}</p>
                  </div>
                </>
              ) : (
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group"></div>
                  <label>User</label>
                  <sup style={{ fontSize: "13px" }}>*</sup>
                  <SelectForm
                    isClearable
                    isSearchable
                    options={(e, cb) => {
                      (async () => await userDropdown(e, cb))();
                    }}
                    placeholder=""
                    isDisabled={state.id == 0 ? false : true}
                    value={user}
                    onChange={(e) => onchange(e, "user")}
                    isMulti={false}
                    async={true}
                  />
                  <p style={{ color: "red" }}>{formErrors["user_isEmpty"]}</p>
                </div>
              )}
              {isHrDod && (
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group"></div>
                  <label>Token Number</label>
                  <sup style={{ fontSize: "13px" }}>*</sup>
                  <InputForm
                    placeholder={""}
                    onChange={(val) => {
                      let value = val.target.value.replace(/[^0-9]/g, "");
                      setTokenNumber(value);
                    }}
                    textArea={false}
                    value={tokenNumber}
                    onKeyPress={(e) => handleKeyPress(e)}
                    maxlength={20}
                    isDisabled={editMode}
                  />
                  <p style={{ color: "red" }}>{formErrors["tokenNumber_isEmpty"]}</p>
                </div>
              )}
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group"></div>
                <label>Email</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm isDisabled={emailDisable ? false : true} placeholder={""} value={email} onChange={(e) => setEmail(e.target.value)} textArea={false} />
                <p style={{ color: "red" }}>{formErrors["email_isEmpty"]}</p>
                {isHrDod && (
                  <div
                    style={{
                      color: "#DB233A",
                      fontSize: "12px",
                      display: "none",
                    }}
                  >
                    Note: Please add Employee's email id that they use to login.
                  </div>
                )}
              </div>

              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group"></div>
                <label>User Role</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <SelectForm
                  options={userRoleOptions}
                  isMulti={false}
                  placeholder={""}
                  value={userRole}
                  isDisabled={userRoleDisabled}
                  onChange={(e) => {
                    // if(e.Id === 1 || e.Id ===  4 || e.Id ===  5){
                    if ([RoleEnum.Admin, RoleEnum.EnrollmentCommittee, RoleEnum.LoanCommittee].includes(e?.Id)) {
                      setUnitCode("");
                      setUnitCodeDisabled(true);
                    } else {
                      setUnitCodeDisabled(false);
                    }
                    setUserRole(e);
                  }}
                />
                {/* <span style={{ color: "red" }}>{validationmessage}</span> */}
                <p style={{ color: "red" }}>{formErrors["userrole_isEmpty"]}</p>
              </div>

              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group"></div>
                <label>Unit Code</label>
                <sup style={{ fontSize: "13px" }}>{[RoleEnum.Admin, RoleEnum.EnrollmentCommittee, RoleEnum.LoanCommittee].includes(userRole?.Id) ? "" : "*"}</sup>
                <SelectForm
                  options={unitCodeOptions}
                  isMulti={true}
                  placeholder={""}
                  value={unitCode}
                  onChange={
                    (e) => setUnitCode(e)
                    //, setValidattionmessage("")
                  }
                  isDisabled={unitCodeDisabled}
                />
                <p style={{ color: "red" }}>{formErrors["unitcode_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <div className="form-group">
                  <label className="col-form-label">Active Status</label>
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      type="checkbox"
                      onChange={(e) => setIsActive(e.target.checked)}
                      name="isActive"
                      checked={isActive}
                      disabled={isActiveMode}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value={<p><i className="far fa-times-circle"></i> Cancel</p> } onClick={() => navigate("/master/UserRoleMapping")} />
          </div>
          {state !== null && state.id && state.id > 0 ? (
            ""
          ) : (
            <div>
                <ButtonForm className="btn btn-cancel" id="Reset" style={{ marginLeft: 5 }} value={<p><i className="fas fa-undo"></i> Reset</p> } onClick={() => ResetFunction()} />
            </div>
          )}
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value={<p><i className="fas fa-paper-plane"></i> Submit</p> } onClick={() => insertUserroleFunction()} />
          </div>
        </div>
      </div>
    </>
  );
};
export default UserRoleMapping;
{
  /* <div className="col-lg-4 col-sm-4 col-xs-4 ">
    <div className="form-group"></div>
    <label>Sector</label>
    <sup style={{ fontSize: "13px" }}>*</sup>
    <InputForm
      isDisabled={true}
      placeholder={""}
      value={sector}
      onChange={() => {}}
      textArea={false}
    />
    <p style={{ color: "red" }}>{formErrors["sector_isEmpty"]}</p>
  </div>
  <div className="col-lg-4 col-sm-4 col-xs-4 ">
    <div className="form-group"></div>
    <label>Company</label>
    <sup style={{ fontSize: "13px" }}>*</sup>
    <InputForm
      isDisabled={true}
      placeholder={""}
      value={company}
      onChange={() => {}}
      textArea={false}
    />
    <p style={{ color: "red" }}>{formErrors["company_isEmpty"]}</p>
  </div>
  <div className="col-lg-4 col-sm-4 col-xs-4 ">
    <div className="form-group"></div>
    <label>Location</label>
    <sup style={{ fontSize: "13px" }}>*</sup>
    <InputForm
      isDisabled={true}
      placeholder={""}
      value={location}
      onChange={() => {}}
      textArea={false}
    />
    <p style={{ color: "red" }}>{formErrors["location_isEmpty"]}</p>
  </div>
  <div className="col-lg-4 col-sm-4 col-xs-4 ">
    <div className="form-group"></div>
    <label>Department</label>
    <sup style={{ fontSize: "13px" }}>*</sup>
    <InputForm
      isDisabled={true}
      placeholder={""}
      value={department}
      onChange={() => {}}
      textArea={false}
    />
    <p style={{ color: "red" }}>
      {formErrors["department_isEmpty"]}
    </p>
  </div>
  <div className="col-lg-4 col-sm-4 col-xs-4 ">
    <div className="form-group"></div>
    <label>Designation</label>
    <sup style={{ fontSize: "13px" }}>*</sup>
    <InputForm
      isDisabled={true}
      placeholder={""}
      value={designation}
      onChange={() => {}}
      textArea={false}
    />
    <p style={{ color: "red" }}>
      {formErrors["designation_isEmpty"]}
    </p>
  </div> */
}
